import script from "./LeaderPortfolioLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderPortfolioLayout.vue?vue&type=script&setup=true&lang=js"

import "./LeaderPortfolioLayout.vue?vue&type=style&index=0&id=57cbca6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57cbca6f"]])

export default __exports__